module.exports = __webpack_public_path__ + "media/click.0e721d35.mp3";